import { Button } from '@highlight/ui'
import { HTMLAttributes } from 'react'
import { X } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

export const CloseButton = ({
  className,
  ...props
}: {
  className?: string
} & HTMLAttributes<HTMLButtonElement>) => {
  return (
    <Button variant="outline" size="sm" shape={'circle'} {...props} className={twMerge('group/close', className)}>
      <X />
    </Button>
  )
}
